import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../services/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {
  @Input() loaderSize: string = '10px';
  @Input() loaderColor: string = 'white';
  @Input() loaderType: string = 'spinner';
  @Input() spinnerType: SpinnerType = SpinnerType.FaSpinner;

  private subscription!: Subscription;
  isVisible: boolean = false;

  constructor(private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.subscription = this.loaderService.loaderState.subscribe({
      next: (state: boolean) => {
        this.isVisible = state;
      }
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}

export enum SpinnerType {
  FaRefresh = 'fa-refresh',
  FaSpinner = 'fa-spinner',
  FaCircleONotch = 'fa-circle-o-notch',
}
